import axios from 'axios';

import { getLang } from '@/helpers/language';

export const statusHandler = {
  401: () => window.bvModal.show('login-required'),
};

export const api = axios.create({
  // TODO: 배포 후 주소 변경
  // baseURL: process.env.VUE_APP_TEST_SERVER,
  timeout: 3000,
  headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Lang: getLang(),
  },
  responseType: 'json',
  withCredentials: true,
});
